import {
  Send,
  Search,
  FileText,
  Stethoscope,
  ClipboardCheck,
  Database,
  Lock,
  Clock,
  MessageSquareText,
  Brain,
  Layers,
  Eye,
  ShieldCheck,
  Laptop,
  Award,
  KeyRound,
  Building2,
  Home,
  MapPin,
  Calendar,
  BadgeCheck,
  ClipboardEdit,
  UserSearch,
  GraduationCap,
  Video,
  HeartPulse,
  BookOpen,
} from "lucide-react";

export const SEO_TITLE =
  "Vaga: Enfermeiro(a) Administrativo Remoto — Entrevista Médica Qualificada | Previsa Saúde";
export const SEO_DESC =
  "Vaga remota para Enfermeiro(a) com COREN ativo: entrevista médica qualificada, análise de Declaração de Saúde e auditoria em saúde. Capacitação presencial em Vila Velha/ES. Candidate-se!";

export const APPLY_EMAIL = "valquiria@previsasaude.com.br";

export const MAILTO_SIMPLE =
  "mailto:valquiria@previsasaude.com.br?subject=Vaga%20Enfermeiro%20Adm%20%E2%80%93%20EMQ&body=Ol%C3%A1%2C%20Previsa%20Sa%C3%BAde.%0A%0ATenho%20interesse%20na%20vaga%20de%20Enfermeiro(a)%20Administrativo%20%E2%80%93%20Entrevista%20M%C3%A9dica%20Qualificada.%0A%0ASegue%20meu%20curr%C3%ADculo%20para%20avalia%C3%A7%C3%A3o.%0A%0AAtenciosamente%2C";

export const floatingChips = [
  { label: "Entrevista Qualificada", icon: MessageSquareText, color: "#3532B3" },
  { label: "Análise Técnica", icon: Search, color: "#3787F5" },
  { label: "Declaração de Saúde", icon: FileText, color: "#12DDB5" },
  { label: "CID-10", icon: BookOpen, color: "#3787F5" },
  { label: "Relatórios Técnicos", icon: ClipboardCheck, color: "#3532B3" },
];

export const highlightCards = [
  {
    icon: Building2,
    title: "Área administrativa em saúde",
    desc: "Atuação em processos técnicos e administrativos da operação.",
    variant: "deepBlue",
  },
  {
    icon: MessageSquareText,
    title: "Entrevista qualificada",
    desc: "Condução técnica com escuta ativa e apuração clínica.",
    variant: "vividBlue",
  },
  {
    icon: ClipboardCheck,
    title: "Auditoria e análise técnica",
    desc: "Leitura crítica de informações, evidências e critérios.",
    variant: "aqua",
  },
  {
    icon: Home,
    title: "Atuação remota com capacitação presencial",
    desc: "Home office com capacitação inicial em Vila Velha/ES.",
    variant: "vividBlue",
  },
];

export const responsibilities = [
  { icon: MessageSquareText, text: "Realizar entrevistas qualificadas com beneficiários e proponentes.", variant: "deepBlue" },
  { icon: Search, text: "Analisar históricos, procedimentos, tratamentos e condições de saúde.", variant: "vividBlue" },
  { icon: ClipboardEdit, text: "Orientar e apoiar o correto preenchimento da Declaração de Saúde — DS.", variant: "aqua" },
  { icon: Stethoscope, text: "Identificar patologias, condições, lesões e doenças preexistentes.", variant: "deepBlue" },
  { icon: HeartPulse, text: "Correlacionar informações com anatomia, fisiologia e CID-10.", variant: "vividBlue" },
  { icon: FileText, text: "Elaborar relatórios técnicos claros, completos e objetivos.", variant: "aqua" },
  { icon: Database, text: "Registrar e atualizar informações em sistemas de gestão em saúde.", variant: "deepBlue" },
  { icon: Lock, text: "Garantir qualidade, consistência e confidencialidade dos dados analisados.", variant: "vividBlue" },
  { icon: Clock, text: "Cumprir prazos e indicadores de qualidade estabelecidos pela operação.", variant: "aqua" },
];

export const profileTraits = [
  { icon: MessageSquareText, title: "Comunicação clara", variant: "deepBlue" },
  { icon: Brain, title: "Raciocínio analítico", variant: "vividBlue" },
  { icon: Layers, title: "Organização", variant: "aqua" },
  { icon: Eye, title: "Atenção aos detalhes", variant: "vividBlue" },
  { icon: ShieldCheck, title: "Postura ética", variant: "deepBlue" },
  { icon: Laptop, title: "Facilidade com tecnologia", variant: "aqua" },
  { icon: Award, title: "Compromisso com qualidade", variant: "vividBlue" },
  { icon: KeyRound, title: "Sigilo e responsabilidade", variant: "deepBlue" },
];

export const requirements = [
  "Graduação completa em Enfermagem.",
  "Registro ativo no COREN.",
  "Domínio de anatomia, fisiologia e CID-10.",
  "Excelente comunicação oral e escrita.",
  "Capacidade de análise, argumentação e investigação de informações.",
  "Organização, atenção aos detalhes e compromisso com a qualidade.",
  "Facilidade para utilizar ferramentas digitais e sistemas de gestão em saúde.",
  "Disponibilidade para participar de capacitação presencial em Vila Velha/ES.",
];

export const differentials = [
  "Experiência com preenchimento ou análise de Declaração de Saúde.",
  "Experiência em auditoria de Enfermagem.",
  "Vivência em operadoras de saúde ou medicina preventiva.",
  "Conhecimento sobre doenças e lesões preexistentes — DLP.",
  "Experiência com entrevistas qualificadas.",
  "Experiência com análise de risco assistencial.",
];

export const jobInfo = [
  {
    icon: BadgeCheck,
    title: "Regime de contratação",
    desc: "Pessoa Jurídica — PJ.",
    variant: "deepBlue",
  },
  {
    icon: KeyRound,
    title: "CNPJ",
    desc: "Necessário possuir CNPJ ativo e emitir nota fiscal, ou ter disponibilidade para abertura.",
    variant: "vividBlue",
  },
  {
    icon: Home,
    title: "Modalidade",
    desc: "Remota, com possibilidade de atuação híbrida.",
    variant: "aqua",
  },
  {
    icon: MapPin,
    title: "Local de referência",
    desc: "Vila Velha/ES.",
    variant: "vividBlue",
  },
  {
    icon: Calendar,
    title: "Carga horária",
    desc: "A definir.",
    variant: "deepBlue",
  },
  {
    icon: GraduationCap,
    title: "Capacitação",
    desc: "Capacitação inicial presencial.",
    variant: "aqua",
  },
];

export const timeline = [
  {
    icon: Send,
    title: "Envio do currículo",
    desc: "O candidato envia o currículo atualizado para avaliação inicial.",
    variant: "deepBlue",
  },
  {
    icon: UserSearch,
    title: "Triagem técnica",
    desc: "A equipe analisa experiência, formação, disponibilidade e aderência ao perfil.",
    variant: "vividBlue",
  },
  {
    icon: Video,
    title: "Entrevista",
    desc: "Os candidatos selecionados participam de conversa com a equipe Previsa Saúde.",
    variant: "aqua",
  },
  {
    icon: GraduationCap,
    title: "Capacitação inicial",
    desc: "Profissionais aprovados participam da capacitação presencial antes do início da operação.",
    variant: "deepBlue",
  },
];
